//
//
//
//
//
//
//

//引入公共字体样式
import './statics/system/font/iconfont.css'
import './statics/system/css/platform.less'
import './statics/workflow/css/workflow.css'
export default {
  
  name: "App",
  mounted() {
    //解决苹果部分机型弹窗后，有些按钮或组件位置错乱问题
    (/iphone|ipod|ipad/i.test(navigator.appVersion)) && document.addEventListener(
    'blur',
      event => {
        // 当页面没出现滚动条时才执行，因为有滚动条时，不会出现这问题
              // input textarea 标签才执行，因为 a 等标签也会触发 blur 事件
          if (
              document.documentElement.offsetHeight <=
              document.documentElement.clientHeight &&
              ['input', 'textarea'].includes(event.target.localName)
          ) {
              document.body.scrollIntoView() // 回顶部
          }
      },
      true
    )
    /*
    this.$http
      .get('api/try/ajax/json_demo.json')
      .then(response => (console.log(response.data)))
      .catch(function (error) { // 请求失败处理
        console.log(error);
      });
      */
  }
};



// WEBPACK FOOTER //
// ./src/App.vue